import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"

import ReceiptCard, { composeAddress, formatPhone, withScheme } from "../ReceiptCard/ReceiptCard"

import styles from "./reviewStep.module.less"

const { Text, Paragraph } = Typography

// Step 5: the "digital receipt" the cardholder sees (shared ReceiptCard), plus a
// read-only summary of the answers. To change anything the merchant picks a step
// on the left (no fields here).
const ReviewStep = ({ buildingBlocks }) => {
  const { t } = useTranslation()
  const bb = buildingBlocks || {}
  const biz = bb.business_info || {}
  const details = bb.business_details || {}
  const support = bb.support_legal || {}
  const supportPhone = formatPhone(support.support_phone)

  const summary = [
    { label: "Business name", value: biz.business_name },
    { label: "Website", value: biz.business_website, url: true },
    { label: "Business address", value: composeAddress(details) },
    { label: "Product or service", value: details.product_description },
    { label: "Support phone", value: supportPhone },
    { label: "Support email", value: support.support_email },
    { label: "Support website", value: support.support_website, url: true },
    { label: "Refund policy", value: support.refund_policy_url, url: true },
    { label: "Cancellation policy", value: support.cancellation_policy_url, url: true },
    { label: "Terms and conditions", value: support.terms_url, url: true }
  ].filter((r) => r.value)

  return (
    <Flex gap={24} wrap="wrap" className={styles.review}>
      <ReceiptCard buildingBlocks={bb} />

      {/* Read-only summary of the merchant's answers. */}
      <div className={styles.summary}>
        {summary.length ? (
          summary.map((row) => (
            <div key={row.label} className={styles.row}>
              <Text type="secondary" className={styles.label}>
                {t(row.label)}
              </Text>
              {row.url ? (
                <a
                  href={withScheme(row.value)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.value}
                >
                  <Paragraph
                    style={{ color: "inherit" }}
                    ellipsis={{ rows: 3, tooltip: row?.value }}
                  >
                    {row.value}
                  </Paragraph>
                </a>
              ) : (
                <Paragraph ellipsis={{ rows: 3, tooltip: row?.value }} className={styles.value}>
                  {row.value}
                </Paragraph>
              )}
            </div>
          ))
        ) : (
          <Text type="secondary">{t("Fill in the previous steps to see your details here.")}</Text>
        )}
      </div>
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  buildingBlocks: state.receiptConfigure.profile.buildingBlocks
})

export default connect(mapStateToProps)(ReviewStep)
